import { connect } from 'react-redux';
import { getUserAuthProfile } from 'web/store/modules/user';
import { getCorporateUrl, getStorEdgeUrl } from 'web/store/modules/company';
import AdminHeader from '../components/AdminHeader';

const mapStateToProps = state => ({
  corporateUrl: getCorporateUrl(state),
  storEdgeUrl: getStorEdgeUrl(state),
  userAuthProfile: getUserAuthProfile(state),
});

export default connect(
  mapStateToProps,
)(AdminHeader);
